<template>
  <div class="xcard">
    <h4 class="text-center" v-if="estado">
      <b>{{ $store.state.unidad.programas }} Activos</b>
    </h4>
    <h4 class="text-center" v-if="!estado">
      <b>{{ $store.state.unidad.programas }} Eliminados</b>
    </h4>

    <v-row>
      <v-col><Sedes :model="sede" @reloadprogramas="getDataProgramas" /></v-col>
      <v-col><gestion-select></gestion-select></v-col>
      <v-col>  
          <v-select v-model="messel" outlined return-object hide-details item-text="text" :items="meses" label="Mes Inicio" dense clearable></v-select>
      </v-col>
      <v-col><categoria-select @change="(v) => (buscar = v ? v.nombre : '')"></categoria-select></v-col>
      <!-- <v-col><fase-select @change="(v) => (buscar = v ? v.nombre : '')"></fase-select></v-col> -->
    </v-row>

    <v-row xstyle="background: #e9f2f7">
      <v-col xl="5" md="6">
        <v-text-field
          dense
          class="ma-0 pa-0"
          background-color="#ffff"
          :disabled="loading"
          hide-details
          outlined
          v-model="buscar"
          label="Buscar programa"></v-text-field>
      </v-col>
      <v-col xl="7" md="6">
        <v-row>
          <v-col xl="3" class="pa-0 ma-0">
            <button
              :disabled="$store.state.isonlyread"
              v-show="programas.length > 0"
              class="btn btn-sm btn-link"
              @click="tableToExcel('table', 'Lorem Table')">
              <span class="glyphicon glyphicon-save-file"></span> EXCEL
            </button>
          </v-col>

          <v-col xl="3" class="pa-0 ma-0">
            <button class="btn btn-sm btn-link" @click="misInscripciones()">
              <span class="glyphicon glyphicon-file"></span> Mis Inscripciones
            </button>
          </v-col>
          <!-- <v-col xl="3" class="pa-0 ma-0" v-if="!$store.state.isonlyread">
            <button
              class="btn btn-link btn-sm"
              v-show="$store.state.createInstitucion"
              data-toggle="modal"
              data-target="#newIns">
              <span class="glyphicon glyphicon-plus"></span> Institucion
            </button>
          </v-col> -->
          <!-- <v-col xl="3" class="pa-0 ma-0">
            <v-checkbox
              class="ma-0 pa-0"
              hide-details
              dense
              v-model="estado"
              :label="`${!estado ? 'Cerrados' : 'Activos'}`"></v-checkbox>
          </v-col> -->
        </v-row>
      </v-col>
    </v-row>

    <p
      class="text-primary mb-0 mt-2"
      title="NOTA: Si la cantidad no concuerda es porque los otros estan en fase Cerrado o Finalizado.">
      {{ items.length }} programas encontrados.
    </p>
    <v-row>
      <v-col sm="6">
        <v-checkbox
          v-model="dispo_inscribir"
          hide-details
          color="purple"
          style="color: purple !important"
          :label="
            dispo_inscribir
              ? 'Solo Visualizar los que tienen fecha de matriculacion disponible'
              : 'Se muestran todos segun convenio, incluyendo los que su fecha de matriculacion no haya comenzado'
          " />
        <v-checkbox
          v-model="omitir_convenio"
          hide-details 
          x-small
          size="small"
          class="mt-0 small"
          color="green"
          style="color: green !important"
          label="Listar Omitiendo el Convenio" />
      </v-col>

      <v-col sm="2">
        <v-btn v-if="
          $store.state.CARGO.id == 14 ||
          $store.state.CARGO.id == 15 ||
          $store.state.CARGO.id == 5 ||
          $store.state.CARGO.id == 6 ||
          $store.state.CARGO.id == 7 ||
          $store.state.CARGO.id == 1" 
          tile
          color="green"
          dark
          :to="'/reportecuenta'"
          title="Reporte cuenta">
          completar
        </v-btn>

      </v-col>
      <!-- <v-col sm="2">
        <v-btn color="orange" dark @click="$refs.refverDashboard.openmodal()" > Dashboard </v-btn>
      </v-col> -->
      <!-- <v-col sm="2" v-if="$store.state.CARGO.id == 1 || $store.state.DATA_USER.id == 65958 || $store.state.DATA_USER.id == 30820 || $store.state.DATA_USER.id==160967">
        <v-btn color="blue" dark @click="$refs.refavatar_upi_data.openmodal()" > Avatar UPI </v-btn>
      </v-col> -->
    </v-row>
    
    <v-progress-linear v-if="loading" indeterminate class="mb-1" />
    <div class="table-responsive" xstyle="xheight: 70vh">
      <table
        ref="table"
        class="tablita table table-condensed table-striped table-hover"
        id="midatatable"
        summary="lorem ipsum sit amet"
        rules="groups"
        frame="hsides">
        <caption v-show="false">
          Reporte de programas:
        </caption>
        <thead style="background: #196391">
          <tr>
            <th class="white--text"><small>No</small></th>
            <th class="white--text" style="min-width: 100px"><small>Codigo</small></th>
            <th class="white--text" style="min-width: 50px"><small>Id</small></th>
            <th class="white--text" style="min-width: 100px"><small>Cod Academico</small></th>
            <th class="white--text" style="min-width: 178px"><small>Programa </small></th>
            <th class="white--text" style="min-width: 50px"><small>Regularizado</small></th>
            <th class="white--text" style="min-width: 50px"><small> Universidad </small></th>
            <th class="white--text"><small>Inicia - Finaliza</small></th>
            <th class="white--text"><small>Modulos</small></th>
            <th class="white--text"><small>Modalidad</small></th>
            <!-- <th class="white--text"> <small>Matricula</small> </th>
                        <th class="white--text"> <small>Colegiatura</small> </th> -->
            <th class="white--text"><small>Etapa</small></th>
            <th class="white--text"><small>Estado</small></th>
            <th class="white--text"><small>Inscritos</small></th>
            <th style="min-width: 228px" class="text-center white--text"><small>Opciones</small></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(p, ind) in items" v-show="p.show">
            <tr :key="p.id" v-if="isfechaMatriculacion(p)">
              <td>{{ ind + 1 }}</td>
              <td>
                <small> {{ p.codigo }}</small>
              </td>
              <td>
                <small> {{ p.code }}</small>
              </td>
              <td>
                <small> {{ p.programa_universidad?.codigo }}</small>
              </td>
              <td :title="p.title">
                <small>{{ p.single_name }} </small>
              </td>
              <td>
                <small> {{ p.es_programa_regularizado?"SI":"NO" }}</small>
              </td>
              <td :title="getuniversity(p)" class="center">
                <small v-show="false">{{ getuniversity(p) }} </small>
                <v-img :src="getuniversityimg(p)" width="30"></v-img>
              </td>
              <td :title="'F. matriculacion: ' + p.fecha_matriculacion">
                <small>{{ p.dates_text }} </small>
              </td>
              <td>
                <small> {{ p.programa_modulos.length }} </small>
              </td>
              <td>
                <small>{{ p.modalidad_text }} </small>
              </td>
              <td :style="getFaseColor(p.fase)">
                <small>{{ getFase(p.fase) }}</small>
              </td>
              <td>
                <template v-if="p.estado_programa">
                  <div v-if="estadosProgramaById[p.estado_programa.parent_id]">
                    <v-chip x-small outlined
                      :color="estadoProgramaColor(estadosProgramaById[p.estado_programa.parent_id].codigo)"
                      class="mb-1">
                      {{ estadosProgramaById[p.estado_programa.parent_id].nombre }}
                    </v-chip>
                    <br>
                    <v-chip x-small dark :color="estadoProgramaColor(p.estado_programa.codigo)">
                      {{ p.estado_programa.nombre }}
                    </v-chip>
                  </div>
                  <v-chip v-else x-small dark :color="estadoProgramaColor(p.estado_programa.codigo)">
                    {{ p.estado_programa.nombre }}
                  </v-chip>
                </template>
                <small v-else>—</small>
              </td>
              <td class="text-center" :title="'Preinscritos: ' + p.preinscritos">
                {{ p.inscriptos }} <small>({{ p.preinscritos }})</small>
              </td>
              <td> 
                <button
                  :title="
                    !isfechaMatriculacionBtnIns(p)
                      ? `La matriculacion inicia: ${p.fecha_matriculacion}`
                      : 'Registrar Inscripciones'
                  "
                  class="btn btn-sm btn-default"
                  xdisabled="p.fase >= 2 && ($store.state.CARGO.id != 1 && $store.state.CARGO.id != 8)"
                  xxdisabled="(p.fase >= 2 || p.fase == 0) && ($store.state.CARGO.id != 1 && $store.state.CARGO.id != 8 && $store.state.CARGO.id != 5 && $store.state.CARGO.id != 6 && $store.state.CARGO.id != 7)"
                  v-show="!$store.state.isonlyread && $store.state.createInscripcion && $store.state.CARGO.id != 24"
                  @click="enrollByModule(p)">
                  <span class="glyphicon glyphicon-education"></span>
                </button>
                <button
                  v-if="
                    !$store.state.isonlyread &&
                    $store.state.CARGO.id != 11 &&
                    $store.state.CARGO.id != 12 &&
                    $store.state.CARGO.id != 13
                  "
                  v-show="sede_permitida"
                  :disabled="$store.state.CARGO.id == 13"
                  class="btn btn-sm btn-default"
                  title="Editar programa rest"
                  @click="editarProgramarest(p)">
                  <span class="glyphicon glyphicon-pencil"></span>
                </button>
                <button class="btn btn-sm btn-default" title="Ver Inscripciones" @click="verInscripciones(p)">
                  <span class="glyphicon glyphicon-list-alt"></span>
                </button>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <button
                      v-bind="attrs"
                      v-on="on"
                      @click="asignarcobradorprog(p)"
                      v-show="
                        $store.state.CARGO.id == 1 ||
                        $store.state.CARGO.id == 14 ||
                        $store.state.CARGO.id == 15 ||
                        $store.state.CARGO.id == 25 ||
                        ($store.state.CARGO.id == 19 && $store.state.CARGO.id != 24)
                      "
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-account-cash</v-icon>
                    </button>
                  </template>
                  <span> Asignar Responsable de cobranza. </span>
                </v-tooltip>
                <button class="btn btn-sm btn-default" title="Ver Detalles" @click="verrest(p)">
                  <span class="glyphicon glyphicon-eye-open"></span>
                </button>
                <button
                  v-if="
                    permitido ||
                    (!$store.state.isonlyread &&
                      $store.state.CARGO.id != 11 &&
                      $store.state.CARGO.id != 12 &&
                      $store.state.CARGO.id != 13 &&
                      $store.state.CARGO.id != 14 &&
                      $store.state.CARGO.id != 24 &&
                      $store.state.CARGO.id != 15 && 
                      $store.state.CARGO.id != 25
                      )
                  "
                  v-show="sede_permitida"
                  :disabled="$store.state.CARGO.id == 13"
                  class="btn btn-sm btn-default"
                  title="Cambiar Fase del programa"
                  @click="aprobarPrograma(p)"
                  data-toggle="modal"
                  data-target="#modalf">
                  <span class="glyphicon glyphicon-random"></span>
                </button>
                <button
                  v-if="
                    !$store.state.isonlyread &&
                    $store.state.CARGO.id != 11 &&
                    $store.state.CARGO.id != 12 &&
                    $store.state.CARGO.id != 13 &&
                    $store.state.CARGO.id != 24
                  "
                  v-show="sede_permitida"
                  :disabled="$store.state.CARGO.id == 13"
                  class="btn btn-sm btn-default"
                  title="Asignar Coordinador a Programa"
                  @click="showDialogCoordinador(p)">
                  <span class="glyphicon glyphicon-user"></span>
                </button>
                <button
                  v-if="
                    !$store.state.isonlyread &&
                    $store.state.CARGO.id != 11 &&
                    $store.state.CARGO.id != 12 &&
                    $store.state.CARGO.id != 13 &&
                    $store.state.CARGO.id != 24
                  "
                  v-show="sede_permitida"
                  :disabled="$store.state.CARGO.id == 13"
                  class="btn btn-sm btn-default"
                  title="Asignar Responsable a Programa"
                  @click="showDialogResponsable(p)">
                  <span class="glyphicon glyphicon-briefcase"></span>
                </button>
                <button
                  v-if="
                    !$store.state.isonlyread &&
                    $store.state.CARGO.id != 11 &&
                    $store.state.CARGO.id != 12 &&
                    $store.state.CARGO.id != 13 &&
                    $store.state.CARGO.id != 14 &&
                    $store.state.CARGO.id != 15 &&
                    $store.state.CARGO.id != 25 &&
                    $store.state.CARGO.id != 24
                  "
                  v-show="sede_permitida"
                  :disabled="!$store.state.deletePrograma"
                  class="btn btn-sm btn-default"
                  title="Eliminar Programa"
                  @click="preDeleteProgramita(p)">
                  <span class="glyphicon glyphicon-trash"></span>
                </button>

                <button
                  v-if="$store.state.CARGO.id == 11 || $store.state.CARGO.id == 12 || $store.state.CARGO.id == 13"
                  :disabled="p.fase >= 2"
                  class="btn btn-sm btn-default"
                  title="Generar Codigo QR de inscripcion."
                  @click="abrirgeneradorEnlace(p)">
                  <span class="glyphicon glyphicon-link"></span>
                </button>

                <button
                  v-if="$store.state.CARGO.id == 1 || $store.state.DATA_USER.id==59716 || $store.state.DATA_USER.id==160967 || $store.state.DATA_USER.id==76447"
                  class="btn btn-sm btn-default"
                  title="Cambiar estado del programa"
                  @click="abrirCambioEstado(p)">
                  <v-icon small class="purple--text">mdi-swap-horizontal</v-icon>
                </button>
                <button                  
                  class="btn btn-sm btn-default"
                  title="Historial de estados"
                  @click="abrirHistorial(p)">
                  <v-icon small class="teal--text">mdi-history</v-icon>
                </button>
                <button
                  v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
                  class="btn btn-sm btn-default"
                  title="Establecer los dias de retraso."
                  @click="abrirretrasosprog(p)">
                  <v-icon small class="blue--text">mdi-alarm-plus</v-icon>
                </button>
                <button
                  v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25"
                  class="btn btn-sm btn-default"
                  title="Verificar Retrasos"
                  @click="openVerificadorCobranzas(p)">
                  <v-icon small class="blue--text">mdi-cash-usd</v-icon>
                </button>
                
                <button
                class="btn btn-sm btn-default"
                title="Ver los webinars de este programa"
                @click="$router.push('/getwebinars?programaid='+p.id+'&name='+p.nombre_compuesto)">
                <v-icon small class="blue--text">mdi-group</v-icon>
              </button>
              <button
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 4 || $store.state.CARGO.id == 26"
                class="btn btn-sm btn-default "
                title="Ver las certificaciones de este programa"
                @click="$router.push('/programasuniversidad/'+p.id)">
                <v-icon small class="orange--text">mdi-file-certificate
                </v-icon>
              </button>
              
              <button
                v-if="($store.state.CARGO.id == 1 || $store.state.CARGO.id == 26 || $store.state.CARGO.id == 6 || $store.state.CARGO.id == 8) && ($store.state.CARGO.sede.unidad_negocio==1 || $store.state.CARGO.sede.unidad_negocio==5 || $store.state.CARGO.sede.unidad_negocio==14 || $store.state.CARGO.sede.unidad_negocio==15)"
                :disabled="!p.course_category_id"
                class="btn btn-sm btn-default"
                :title="p.course_category_id?'Abrir programa en moodle':'El programa no tiene asignado la categoria ID del moodle'"
                @click="openMoodleCategory(p)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 128 128"><radialGradient id="deviconMoodle0" cx="532.855" cy="-537.557" r="209.76" gradientTransform="matrix(1 0 0 -1 -297.6 -460.9)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#FAAF40"/><stop offset=".043" stop-color="#F9A538"/><stop offset=".112" stop-color="#F89D31"/><stop offset=".227" stop-color="#F89A2F"/><stop offset=".528" stop-color="#F7922D"/><stop offset="1" stop-color="#F37B28"/></radialGradient><path fill="url(#deviconMoodle0)" d="M106.259 105.754V66.975c0-8.164-3.397-12.244-10.034-12.244c-6.629 0-10.034 4.08-10.034 12.244v38.779H66.294V66.975c0-8.164-3.228-12.244-9.862-12.244c-6.633 0-10.036 4.08-10.036 12.244v38.779H26.667V64.768c0-8.504 2.891-14.801 8.844-19.223c5.102-3.91 12.246-5.777 20.92-5.777c9.015 0 15.478 2.207 19.727 6.801c3.57-4.594 10.207-6.801 19.897-6.801c8.844 0 15.819 1.867 20.922 5.777c5.951 4.422 8.843 10.719 8.843 19.223v41.152h-19.563v-.166z"/><path fill="#58595B" d="m28.539 49.627l-2.041 10.207c18.708 6.291 36.395.166 45.751-16.158c-13.778-9.522-26.535.17-43.71 5.951"/><linearGradient id="deviconMoodle1" x1="324.268" x2="368.932" y1="-509.952" y2="-509.952" gradientTransform="matrix(1 0 0 -1 -297.6 -460.9)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#929497"/><stop offset=".124" stop-color="#757578"/><stop offset=".279" stop-color="#575658"/><stop offset=".44" stop-color="#403E3F"/><stop offset=".609" stop-color="#302D2E"/><stop offset=".788" stop-color="#262223"/><stop offset="1" stop-color="#231F20"/></linearGradient><path fill="url(#deviconMoodle1)" d="M28.539 47.08c-.681 3.91-1.192 7.65-1.872 11.563c17.857 6.125 35.375.85 44.73-15.137c-11.909-13.776-25.17-2.383-42.858 3.574"/><linearGradient id="deviconMoodle2" x1="332.834" x2="351.377" y1="-495.051" y2="-521.534" gradientTransform="matrix(1 0 0 -1 -297.6 -460.9)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#231F20"/><stop offset="1" stop-color="#231F20" stop-opacity="0"/></linearGradient><path fill="url(#deviconMoodle2)" d="M49.799 51.668c-8.164-1.701-17.009 2.555-23.131 6.975c-3.912-28.57 13.777-27.893 36.903-20.75c-1.529 6.975-4.083 16.33-8.502 21.941c-.169-3.744-1.869-6.293-5.27-8.166"/><linearGradient id="deviconMoodle3" x1="299.778" x2="381.412" y1="-495.802" y2="-495.802" gradientTransform="matrix(1 0 0 -1 -297.6 -460.9)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#929497"/><stop offset=".124" stop-color="#757578"/><stop offset=".279" stop-color="#575658"/><stop offset=".44" stop-color="#403E3F"/><stop offset=".609" stop-color="#302D2E"/><stop offset=".788" stop-color="#262223"/><stop offset="1" stop-color="#231F20"/></linearGradient><path fill="url(#deviconMoodle3)" d="M2.178 47.08c29.932-18.031 46.77-21.43 81.634-25c-40.478 31.969-41.499 25-81.634 25"/><path fill="none" stroke="#4A4A4C" stroke-width=".5" d="M83.812 22.246L51.667 45.545"/><path fill="#231F20" d="M45.545 34.66c.34 3.744-.511-3.572 0 0" opacity=".23"/><path fill="none" stroke="#A8ABAD" stroke-width=".5" d="m2.178 47.08l49.489-1.535"/><path fill="none" stroke="#F16922" stroke-width=".5" d="M42.484 35.002C33.98 37.383 6.09 43.506 5.747 47.08c-.849 6.631-.167 17.176-.167 17.176"/><path fill="#F16922" d="M8.131 89.596c-3.063-7.652-6.804-16.158-2.384-26.703C8.64 72.756 8.131 80.24 8.131 89.596"/><path fill="#6D6E70" d="M41.076 33.844c.708-.25 1.384-.17 1.509.184c.126.355-.344.846-1.052 1.096c-.709.256-1.384.172-1.51-.184c-.127-.352.344-.844 1.053-1.096z"/></svg>
              </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <Alertas ref="alertar" />
    <dialog-assign-coordinador ref="refCoordinador" />
    <dialog-assign-responsable ref="refResponsable" />
    <modal id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    <modalc id="modalc" v-bind:obj="correoto" v-on:exito="modalExitoCorreo" />
    <modalf id="modalf" v-bind:obj="seleccionadof" v-on:exito="modalExitof" :prog="seleccionadof.prog" />
    <newIns id="newIns" v-on:exito="modalExitof" />
    <div><AsignarCobradorProg ref="asignarcobradorprog" /></div>
    <notifications group="auth" position="bottom right" />
    <notifications group="auth2" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
    <div><genenlace ref="generarenlace" /></div>
    <verDashboard ref="refverDashboard" />
    <avatar_upi_data ref="refavatar_upi_data" />

    <!-- Diálogo: Historial de estados del programa -->
    <v-dialog v-model="dialogHistorial" max-width="600" scrollable>
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold">
          <v-icon left color="teal">mdi-history</v-icon>
          Historial de estados
        </v-card-title>
        <v-card-subtitle v-if="progHistorial" class="pb-0">
          {{ progHistorial.nombre_compuesto }}
        </v-card-subtitle>
        <v-divider />
        <v-card-text style="max-height: 520px;">
          <div v-if="loadingHistorial" class="text-center py-6">
            <v-progress-circular indeterminate color="teal" />
          </div>
          <div v-else-if="historialEstados.length === 0" class="text-center grey--text py-6">
            Sin historial registrado
          </div>
          <v-timeline v-else dense>
            <v-timeline-item
              v-for="(h, i) in historialEstados"
              :key="i"
              :color="estadoProgramaColor(h.estado_actual && h.estado_actual.codigo)"
              small>
              <v-card outlined class="mb-1">
                <v-card-text class="pa-3">
                  <!-- Transición de estados -->
                  <div class="d-flex align-center flex-wrap mb-2" style="gap:4px">
                    <template v-if="h.estado_anterior">
                      <v-chip x-small dark :color="estadoProgramaColor(h.estado_anterior.codigo)">
                        {{ h.estado_anterior.nombre }}
                      </v-chip>
                      <v-icon small class="mx-1">mdi-arrow-right</v-icon>
                    </template>
                    <v-chip v-if="h.estado_actual" x-small dark :color="estadoProgramaColor(h.estado_actual.codigo)">
                      {{ h.estado_actual.nombre }}
                    </v-chip>
                  </div>

                  <!-- Fechas y duración -->
                  <div class="caption grey--text text--darken-1">
                    <span><v-icon x-small>mdi-calendar-start</v-icon> {{ h.fecha_inicio }}</span>
                    <span v-if="h.fecha_fin" class="ml-2">
                      <v-icon x-small>mdi-calendar-end</v-icon> {{ h.fecha_fin }}
                    </span>
                    <v-chip v-if="h.fecha_fin === null" x-small color="green lighten-4" text-color="green darken-2" class="ml-2">
                      Activo
                    </v-chip>
                    <span v-if="h.duracion_segundos" class="ml-2">
                      <v-icon x-small>mdi-timer-outline</v-icon> {{ formatDuracion(h.duracion_segundos) }}
                    </span>
                  </div>

                  <!-- Motivo y origen -->
                  <div v-if="h.payload && h.payload.motivo" class="caption mt-1">
                    <v-icon x-small color="grey">mdi-comment-text-outline</v-icon>
                    {{ h.payload.motivo }}
                  </div>
                  <div class="caption grey--text mt-1">
                    <v-icon x-small>mdi-account-outline</v-icon>
                    {{ (h.payload && h.payload.usuario) || h.usuario_id || '—' }}
                    <span v-if="h.origen" class="ml-2">
                      <v-icon x-small>mdi-source-branch</v-icon> {{ h.origen }}
                    </span>
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogHistorial = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo: Cambiar estado del programa -->
    <v-dialog v-model="dialogCambioEstado" max-width="480" persistent>
      <v-card v-if="progCambioEstado">
        <v-card-title class="subtitle-1 font-weight-bold">
          <v-icon left color="purple">mdi-swap-horizontal</v-icon>
          Cambiar estado del programa
        </v-card-title>
        <v-card-subtitle class="pb-0">
          {{ progCambioEstado.nombre_compuesto }}
        </v-card-subtitle>
        <v-card-text class="pt-4">
          <v-select
            v-model="cambioEstadoPadre"
            :items="estadosPadres"
            item-text="nombre"
            return-object
            label="Estado"
            outlined dense
            @change="cambioEstadoHijo = null"
          >
            <template v-slot:item="{ item }">
              <v-chip x-small dark :color="estadoProgramaColor(item.codigo)" class="mr-2">
                {{ item.nombre }}
              </v-chip>
            </template>
            <template v-slot:selection="{ item }">
              <v-chip x-small dark :color="estadoProgramaColor(item.codigo)">
                {{ item.nombre }}
              </v-chip>
            </template>
          </v-select>

          <v-select
            v-if="estadosHijosDisponibles.length > 0"
            v-model="cambioEstadoHijo"
            :items="estadosHijosDisponibles"
            item-text="nombre"
            return-object
            label="Sub-estado"
            outlined dense
            class="mt-2"
          >
            <template v-slot:item="{ item }">
              <v-chip x-small dark :color="estadoProgramaColor(item.codigo)" class="mr-2">
                {{ item.nombre }}
              </v-chip>
            </template>
            <template v-slot:selection="{ item }">
              <v-chip x-small dark :color="estadoProgramaColor(item.codigo)">
                {{ item.nombre }}
              </v-chip>
            </template>
          </v-select>

          <v-textarea
            v-model="cambioEstadoMotivo"
            label="Motivo (opcional)"
            outlined dense auto-grow rows="2"
            class="mt-2"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogCambioEstado = false" :disabled="guardandoCambioEstado">Cancelar</v-btn>
          <v-btn
            color="purple" dark
            :loading="guardandoCambioEstado"
            :disabled="!cambioEstadoPadre || (estadosHijosDisponibles.length > 0 && !cambioEstadoHijo)"
            @click="guardarCambioEstado">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style lang="css">
  .tablita th {
    cursor: pointer;
  }
  .tablita th,
  .tablita td {
    white-space: inherit !important;
  }
</style>
<script>
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import modal from '@/components/AEstado.vue';
  import modalc from '@/components/ACorreoAll.vue';
  import newIns from '@/components/ANewInstitucion.vue';
  import modalf from '@/components/AAprobarPrograma.vue';
  // import modals from '@/components/ASubirFasePrograma.vue'
  // import modalb from '@/components/ABajarFasePrograma.vue'
  import Alertas from '@/components/AAlertas.vue';
  import Sedes from '@/components/ASedes-programas.vue';
  // import Gestiones from '@/components/AGestiones';
  import { parseJsonError, exito, error } from '@/components/Utils.js';
  import { mapState } from 'vuex';
  import DialogAssignCoordinador from '@/components/vuetify/DialogAssignCoordinador.vue';
  import DialogAssignResponsable from '@/components/vuetify/DialogAssignResponsable.vue';
  import CategoriaSelect from '@/components/vuetify/CategoriaSelect.vue';
  // import FaseSelect from '@/components/vuetify/FaseSelect.vue';
  import GestionSelect from '../components/vuetify/GestionSelect.vue';
  import AsignarCobradorProg from '@/components/AAsignarCobradorProg.vue';
  import genenlace from '@/components/AGenerarEnlace.vue';
  import verDashboard from './ver-dashboard.vue';
  import avatar_upi_data from './avatar_upi_data.vue';

  export default {
    data() {
      return {
        omitir_convenio: false,
        dispo_inscribir: true,
        permitido: false,
        api_rest: process.env.VUE_APP_API_REST,
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL
        buscar: '',
        txt_btn_listar: 'Ver Mas',
        correoto: { xid: -1, xtitle: 'X', xbody: 'X', all: false, isDefault: false, xsql: null },
        seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
        seleccionadof: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, prog: {} },
        seleccionadop: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, prog: {} },
        msg: '',
        items: [],
        cursor: 10000000,
        loading: false,
        estado: true,
        sede: { idsede: null },
        sede_permitida: false,
        menu_name: process.env.VUE_APP_NAME_MENU,
        xuniversidades: [],
        programas_all: [],
        estadosPrograma: [],
        dialogCambioEstado: false,
        progCambioEstado: null,
        dialogHistorial: false,
        progHistorial: null,
        historialEstados: [],
        loadingHistorial: false,
        cambioEstadoPadre: null,
        cambioEstadoHijo: null,
        cambioEstadoMotivo: '',
        guardandoCambioEstado: false,
        messel:null,
        meses: [
        { id: 0, text: 'Enero' },
        { id: 1, text: 'Febrero' },
        { id: 2, text: 'Marzo' },
        { id: 3, text: 'Abril' },
        { id: 4, text: 'Mayo' },
        { id: 5, text: 'Junio' },
        { id: 6, text: 'Julio' },
        { id: 7, text: 'Agosto' },
        { id: 8, text: 'Septiembre' },
        { id: 9, text: 'Octubre' },
        { id: 10, text: 'Noviembre' },
        { id: 11, text: 'Diciembre' },
      ],
      };
    },
    components: {
      modal,
      modalc,
      modalf,
      Alertas,
      // Gestiones,
      newIns,
      DialogAssignCoordinador,
      DialogAssignResponsable,
      CategoriaSelect,
      // FaseSelect,
      GestionSelect,
      Sedes,
      AsignarCobradorProg,
      genenlace,
      verDashboard,
      avatar_upi_data,
    },
    watch: {
      estado() {
        this.modalExito();
      },
      '$store.state.CARGO': function () {
        this.cursor = 10000000;
        this.getDataProgramas(true);
      },
      'omitir_convenio': function () {
        this.cursor = 10000000;
        this.getDataProgramas(true);
      },
      'sede.idsede': function (a) {
        if (a == null) return;
        this.cursor = 10000000;
        var cargo = this.$store.state.CARGOS.find((x) => x.idsede == a.id);
        if (cargo) this.$store.state.CARGO = cargo;
        else {
          this.$store.state.updatePrograma = false;
          this.$store.state.asignarAula = false;
          this.$store.state.aprobarPrograma = false;
          this.items = [];
          this.getDataProgramas(false);
        }
      },
      '$store.state.convenio': function () {
        if (this.$store.state.convenio) {
          //window.console.log('>>>>>', this.$store.state, this.items);
          this.filter_programas();
          //this.getDataProgramas();
        }
      },
      gestion(value) {
        if (value == null) return;
        this.cursor = 10000000;
        //this.getDataProgramas();
        this.filter_programas();
      },
      messel: function(){
        this.filtrarmeses();
      },
      buscar(value) {
        this.buscador(value.trim());
      },
      UNIDAD_NEGOCIO_ID() {
        //this.getDataProgramas();
        this.filter_programas();
      },
      /*programas(values) {
        this.filter_programas(values);
      },*/
    },
    computed: {
      ...mapState({
        gestion: (state) => {
          let anio = null;
          if (state.gestion.value) anio = state.gestion.value.gestion;
          else {
            anio = new Date().getFullYear();
          }
          return anio;
        },
        sede_id: (state) => state.CARGO.sede.id,
        programa: (state) => state.programa.value,
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
        programas(state) {
          let data = state.programa.items;
          data.sort((a, b) => b.id - a.id);
          return data;
        },
      }),
      estadosProgramaById() {
        const map = {};
        this.estadosPrograma.forEach(e => { map[e.id] = e; });
        return map;
      },
      estadosPadres() {
        return this.estadosPrograma.filter(e => !e.parent_id);
      },
      estadosHijosDisponibles() {
        if (!this.cambioEstadoPadre) return [];
        return this.estadosPrograma.filter(
          e => e.parent_id === this.cambioEstadoPadre.id && !e.es_calculado
        );
      },
    },

    methods: {
      async abrirHistorial(p) {
        this.progHistorial = p;
        this.historialEstados = [];
        this.dialogHistorial = true;
        this.loadingHistorial = true;
        try {
          const res = await xaxios.request({
            method: 'get',
            url: `${process.env.VUE_APP_API_REST}/api/v1/programa/${p.id}/estado-historial`,
          });
          const d = res.data;
          window.console.log('[historial-estado] raw:', d);
          const historial = d?.historial ?? d?.data?.historial ?? (Array.isArray(d) ? d : []);
          window.console.log('[historial-estado] historial:', historial);
          this.historialEstados = historial;
        } catch (e) {
          window.console.error('[historial-estado]', e?.response?.data || e.message);
        } finally {
          this.loadingHistorial = false;
        }
      },
      formatDuracion(segundos) {
        if (!segundos) return '';
        const d = Math.floor(segundos / 86400);
        const h = Math.floor((segundos % 86400) / 3600);
        const m = Math.floor((segundos % 3600) / 60);
        if (d > 0) return `${d}d ${h}h`;
        if (h > 0) return `${h}h ${m}m`;
        return `${m}m`;
      },
      abrirCambioEstado(p) {
        this.progCambioEstado = p;
        this.cambioEstadoPadre = null;
        this.cambioEstadoHijo = null;
        this.cambioEstadoMotivo = '';
        this.dialogCambioEstado = true;
      },
      async guardarCambioEstado() {
        this.guardandoCambioEstado = true;
        const us = this.$store.state.DATA_USER;
        const usuario = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido || ''}`.trim();
        const body = {
          programa_id: this.progCambioEstado.id,
          estado_programa_codigo: this.cambioEstadoPadre.codigo,
        };
        if (this.cambioEstadoHijo) body.categoria_programa_codigo = this.cambioEstadoHijo.codigo;
        if (this.cambioEstadoMotivo) body.payload = { motivo: this.cambioEstadoMotivo, usuario };
        try {
          await xaxios.request({
            method: 'patch',
            url: `${process.env.VUE_APP_API_REST}/api/v1/programa/estado-programa`,
            data: body,
          });
          this.$notify({ group: 'auth', title: 'Estado actualizado', type: 'success' });
          this.dialogCambioEstado = false;
          this.cursor = 10000000;
          this.getDataProgramas();
        } catch (e) {
          const msg = e?.response?.data?.message || 'Error al cambiar el estado';
          this.$notify({ group: 'auth', title: msg, type: 'error' });
        } finally {
          this.guardandoCambioEstado = false;
        }
      },
      async getEstadosPrograma() {
        try {
          const res = await xaxios.request({ method: 'get', url: `${process.env.VUE_APP_API_REST}/api/v1/programa/estados` });
          const d = res.data;
          window.console.log('[estados-programa] respuesta:', d);
          this.estadosPrograma = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
          window.console.log('[estados-programa] cargados:', this.estadosPrograma.length);
        } catch (e) {
          window.console.error('[estados-programa] error:', e?.response?.status, e?.response?.data || e.message);
        }
      },
      estadoProgramaColor(codigo) {
        const map = {
          COMERCIALIZACION:                           'orange darken-1',
          EN_CURSO_INICIADO_EN_TIEMPO:                'green darken-2',
          EN_ARRASTRE_INICIADO_EN_ARRASTRE:           'orange darken-2',
          EN_ARRASTRE_INICIADO_SIN_PUNTO_EQUILIBRIO:  'deep-orange darken-2',
          EN_ARRASTRE_DESCARTADO_NO_EJECUTADO:        'grey darken-1',
          INICIADO_MODULO_0:                          'teal',
          EN_CURSO_FINALIZADO_MODULO_0:               'teal darken-2',
          DESARROLLO:                                 'blue',
          EN_CURSO_FINALIZADO_DESARROLLO:             'blue darken-2',
          CULMINADO:                                  'cyan darken-1',
          TITULADO:                                   'blue darken-3',
          EN_PROCESO_TITULACION:                      'blue lighten-1',
          SE_QUEDA_EN_CULMINADO:                      'cyan darken-2',
          DADO_DE_BAJA:                               'red darken-1',
          NO_PASO_ETAPA_TESTEO:                       'red',
          NO_ALCANZO_CANTIDAD_MINIMA:                 'red darken-2',
          NO_DOCENTES_ESPECIALIZADOS:                 'red lighten-1',
          PROBLEMAS_ORGANIZACION:                     'red darken-3',
        };
        return map[codigo] || 'grey';
      },
      filtrarmeses(){
        if( !this.messel ){
          this.items = this.programas_all.filter(()=> true) ;
          return; 
        }
        const mes = (this.messel.id+1+'').padStart(2,'0');
        const xmes = `-${mes}-`
        this.items = this.programas_all.filter(p=> {
          return p.fecha_inicio.includes(xmes);
        })  
      },
      filter_programas(/* values = [] */) {
        // window.console.log(values);
        this.getDataProgramas(); 
      },
      showDialogCoordinador(programa) {
        this.$refs.refCoordinador.showThisView(programa);
      },
      showDialogResponsable(programa) {
        this.$refs.refResponsable.showThisView(programa);
      },
      formatCode(program) {
        return `${program.postgrado.categoria.nombre.slice(0, 1)}-${program.id}`.toUpperCase();
      },enrollByModule(programa) { 
        const univ = programa.universidad?.id
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let rol = this.$store.state.CARGO.id;
        let sedeid = this.$store.state.CARGO.sede.id;
        window.console.log(univ, unidad, rol,sedeid);
        
        // habilitacion del boton, master academico, ti y gestion empresarial
        const roles_perm = [1,8,6,26]
        const perm1 = (univ == 9 && (unidad == 1 || unidad == 5)) && !roles_perm.includes(rol)
        if(perm1 && sedeid != 134) {
          this.$root.$notify.show(`Proceso no valido, debe usar Contactos MKT`, {
            color: 'red',
            x: 'right',
          });
          return;
        }

        this.$store.dispatch('programa/selectPrograma', programa);
        if (
          this.$store.state.CARGO.id == 1 ||
          this.$store.state.CARGO.id == 5 ||
          this.$store.state.CARGO.id == 6 ||
          this.$store.state.CARGO.id == 7 ||
          this.$store.state.CARGO.id == 8 ||
          this.$store.state.CARGO.id == 9 || 
          this.$store.state.CARGO.id == 17 || 
          this.$store.state.CARGO.id == 22 || 
          this.$store.state.CARGO.id == 23 || 
          this.$store.state.CARGO.id == 26
        ) {
          this.$router.push({ name: 'enroll.module' });
        } else {
          let date = new Date(programa.fecha_matriculacion);
          let now = new Date();
          if (date > now) {
            let fs = programa.fecha_matriculacion.split('-');
            this.$root.$notify.show(`La fecha de matriculacion inicia: ${fs[2]}/${fs[1]}/${fs[0]}`, {
              color: 'red',
              x: 'right',
            });
            return;
          }

          let unidad = this.$store.state.CARGO.sede.unidad_negocio;
          let rol = this.$store.state.CARGO.id;
          if( programa.fase != 1 && unidad == 1){
            if(rol != 6 && rol != 7 && rol != 5 ){
              this.$root.$notify.show(`Solo se puede inscribir en la fase de inscripciones`, {color:'red',x: 'right',});
              return;
            }
          }

          window.sessionStorage.setItem('xprograma', JSON.stringify(this.programa));
          window.sessionStorage.setItem('route_ins', 'programas');
          sessionStorage.removeItem('xpreinscrito');
          sessionStorage.removeItem('xinscritotoplan');

          // if (process.env.VUE_APP_NAME === 'CIBERKIDS') {
          //   this.$router.push({ name: 'createInscripcionCK' });
          // } else {
          this.$router.push({ name: 'inscripcionrest' });
          // }
        }
      },
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'programas.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      isSedePermitida(sede_actual) {
        var sed = this.$store.state.CARGOS.find((x) => x.idsede == sede_actual);
        this.sede_permitida = sed != null;
      },
      getuniversity(p) {
        if (!p.universidad) return '-';
        return p.universidad.nombre;
      },
      isfechaMatriculacion(programa) {
        if (!this.dispo_inscribir) return true;
        let date = new Date(programa.fecha_matriculacion);
        let now = new Date();
        if (date < now) return true;
        else return false;
      },
      isfechaMatriculacionBtnIns(programa) {
        const idrol = this.$store.state.CARGO.id;
        if (idrol == 8 || idrol == 1) return false;
        let date = new Date(programa.fecha_matriculacion);
        let now = new Date();
        if (date < now) return true;
        else return false;
      },
      getuniversityimg(p) {
        if (!p.universidad) return '?';
        else if (p.universidad.id == 2) return 'img/logo_uajms.png';
        else if (p.universidad.id == 9) return 'img/sigloxxlogo.png';
        else if (p.universidad.id == 52) return 'img/qrlogo.png';
        else if (p.universidad.id == 128) return 'img/ubj.png';
        else if (p.universidad.id == 130) return 'img/logo_wobi.jpg';
        else if (p.universidad.id == 49) return 'img/logo_uap.png';
        else if (p.universidad.id == 301) return 'img/logo_upi.svg';
        else if (p.universidad.id == 157) return 'img/logo_dbs.png';
        else if (p.universidad.id == 226) return 'img/logo_ispi.png';
        else if (p.universidad.id == 20) return 'img/ballivian_logo.jpeg';
        return '';
      },
      parsePrograma(p) {
        if (p == null) return '';
        var cat = p.postgrado.categoria.nombre;
        var nom = p.nombre_compuesto;
        nom = nom.replace(cat + ' -', ' ');
        return nom;
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      parseModalidad(mod) {
        if (mod == 'S') return 'Semipresencial';
        else if (mod == 'P') return 'Presencial';
        else if (mod == 'V') return 'Virtual';
        else return mod;
      },
      asignarcobradorprog(prog) {
        //this.$refs.asignarcobradorprog.open(prog);
        this.$router.push({ name: 'programacobradores', params: { prog: prog } });
      },

      async getDataProgramas() {
        // this.$refs.alertar.cargando();
        this.msg = '0 programas';
        this.isSedePermitida(this.sede_id);
        this.buscar = '';
        this.loading = true;
        this.items = [];
        this.messel = null;
        this.$store.dispatch('programa/setProgramas', []);
        // el estado siempre es true, los programas no se eliminan,
        // pero si la fase es cerrado o finalizado se lo miestra en la vista como si fueran eliminados
        const with_gestion = this.gestion && this.gestion != 'todos' ? ' gestion:' + this.gestion : '';
        let with_convenio = this.$store.state.convenio ? ', iduniversidad: ' + this.$store.state.convenio.id : '';
        if (this.UNIDAD_NEGOCIO_ID != 1 && this.UNIDAD_NEGOCIO_ID != 10) with_convenio = '';
        if( this.omitir_convenio ) with_convenio = '';

        // window.console.log(this.sede_id, with_gestion);
        var sql = gql`query{ getProgramas(cursor:${this.cursor},estado:true,idsede:${this.sede_id}, ${with_gestion} ${with_convenio}){ programa_modulos{ id, idmodulo,iddocente,idprograma,course_id, inicio, fin, programa{id,nombre_compuesto,plataforma_id} modulo{id, sigla,nombre}, docente{id,email,num_doc,nombres,pri_apellido,seg_apellido,usuario_moodle,clave_moodle,telefono1}, estado},id,plataforma_id, course_category_id,
                        fase,modalidad,version,grupo,arte,fecha_inicio,fecha_fin,fecha_matriculacion,gestion,mod_finalizado,sucursal_id,estado,inscripciones{id,estado_ins},sede{id,nombre,unidad_negocio},universidad{id,nombre},codigo,nombre_compuesto,postgrado{id,nombre,area{id,nombre},categoria{id,nombre}},programa_universidad_id,programa_universidad{id,codigo},es_programa_regularizado,estado_programa_id
    estado_programa{
      id
      nombre
      parent_id
      codigo
      activo
    }} }`;
        await this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            let datos = data.getProgramas;
            datos.map((program) => {
              program.inscriptos = program.inscripciones.filter((std) => std.estado_ins == 1).length;
              program.preinscritos = program.inscripciones.filter((std) => std.estado_ins == 0).length;
              program.code = this.formatCode(program);
              // program.fase_text = this.getFase(program.fase);
              program.single_name = this.parsePrograma(program);
              program.modalidad_text = this.parseModalidad(program.modalidad);
              program.dates_text =
                this.formatDate(program.fecha_inicio) + '  - \n' + this.formatDate(program.fecha_fin);
              program.title = `${program.id} - gestion: ${program.gestion}, sede: ${program.sede.nombre}`;
              if (program.universidad) {
                let existe = this.xuniversidades.find((u) => u.id == program.universidad.id);
                if (!existe) this.xuniversidades.push(program.universidad);
              }
              program.show = true;
              if (!program.fecha_matriculacion) program.fecha_matriculacion = program.fecha_inicio;
              //return program;
            });

            this.$store.dispatch('programa/setProgramas', datos);
            this.items = datos;
            this.programas_all = [...datos];
            //this.filter_programas();
            //window.console.log('hay programasjajaaj....');

            if (datos != null && datos.length > 0) {
              this.cursor = datos[datos.length - 1].id;
            }
            this.loading = false;
          })
          .catch(() => {
            // this.$root.$notify.show('');
            this.loading = false;
          });
      },
      getFase(fase) {
        //'inscripciones, en desarrollo, en tramite, cerrado',
        if (fase == 0) return 'NO APROBADO';
        else if (fase == 1) return 'INSCRIPCIONES';
        else if (fase == 2) return 'EN DESARROLLO';
        else if (fase == 3) return 'CONCLUIDO';
        else if (fase == 4) return 'ELABORACION TRABAJOS FINALES';
        else if (fase == 5) return 'RECEPCION DE REQUISITOS DE TITULACION ';
        else if (fase == 6) return 'ARMADO CARPETAS';
        else if (fase == 7) return 'PAGO ARANCELES';
        else if (fase == 8) return 'PROCESO TITULACION';
        else if (fase == 9) return 'CERTIFICADOS ENTREGADOS';
        else if (fase == 10) return 'NO EJECUTADO';
        else return 'DESCONOCIDO: ' + fase;
      },
      getFaseColor(fase) {
        if (fase == 0) return 'background:#F2DEDE';
        else if (fase == 1) return 'background:#D9F0D9';
        else if (fase == 2) return 'background:#A8FFA8';
        else if (fase == 3) return 'background:#EFFFA8';
        else if (fase == 4) return 'background:#FFC8A8';
        else if (fase == 5) return 'background:#E3F2FD';
        else if (fase == 6) return 'background:#FFFDE7';
        else if (fase == 7) return 'background:#FFEBEE';
        else if (fase == 8) return 'background:#F9FBE7';
        else if (fase == 9) return 'background:#EFEBE9';
        else return '';
      },
      listarMas() {
        this.getDataProgramas();
      },
      showEliminar(id) {
        var obj = this.programas.find((x) => x.id == id);
        var msg = 'Cambiar Estado';
        var body =
          'El ' +
          this.menu_name +
          " '" +
          obj.postgrado.categoria.nombre +
          ': ' +
          obj.postgrado.nombre +
          "'sera cambiado.";
        var estad = !obj.estado;
        var tag = gql`mutation{ cambiarEstadoPostgrado(input:{id:${id},estado:${estad}}){ok,errors{message}} }`;
        this.seleccionado = { xid: obj.id, xtitle: msg, xbody: body, xsql: tag };
      },

      showInscripcion(p) {
        if (p.fase > 2) {
          this.$notify(
            exito(
              'AVISO:',
              'Este programa no esta en fase de inscripciones, contacte con parte academica si tiene algun inconveniente.',
            ),
          );
        } else {
          window.sessionStorage.setItem('xprograma', JSON.stringify(p));
          window.sessionStorage.setItem('route_ins', 'programas');
          this.$router.replace({ name: 'inscripcionadd' });
        }
      },
      editarPrograma(p) {
        this.$store.dispatch('programa/selectPrograma', p);
        window.sessionStorage.setItem('xprograma', JSON.stringify(p));
        this.$router.push({ name: 'programamod' });
      },
      editarProgramarest(pro) {
        window.localStorage.setItem('rest_idprograma', pro.id);
        this.$router.push({ name: 'programaviewrest' });
      },
      showAsignarAula(p) {
        this.$store.dispatch('programa/selectPrograma', p);
        window.sessionStorage.setItem('xprograma', JSON.stringify(p));
        this.$router.push({ name: 'asignaraula' });
      },
      verInscripciones(programa) {
        const userrol = this.$store.state.CARGO.id;
        const sedeprog = programa.sede.id;
        const sedeactual = this.$store.state.CARGOS.find(s=>s.idsede==sedeprog);
        // window.console.log('>>',userrol,sedeactual,sedeprog);
        const iduser = this.$store.state.DATA_USER.id;
        const permitido = 6023;
        
        if( !sedeactual && (userrol!=1 || userrol!=8) ){
          if(permitido != iduser){
            this.$root.$notify.show(`No tienes permitido realizar esta accion, o el programa es de otra sede.`, {
              color: 'red',
              x: 'right',
            });
            return;
          }
        } 
        //window.sessionStorage.setItem('xprograma', JSON.stringify(programa)); // lo uso en la lista de inscritos
        this.$store.dispatch('programa/selectPrograma', programa);
        this.$router.push({ name: 'programains' });
      },
      generarCertificados(p) {
        this.$store.dispatch('programa/selectPrograma', p);
        window.sessionStorage.setItem('xprograma', JSON.stringify(p));
        this.$router.push({ name: 'certificadostodos' });
      },
      ver(p) {
        this.$store.dispatch('programa/selectPrograma', p);
        window.sessionStorage.setItem('xprograma', JSON.stringify(p));
        this.$router.push({ name: 'programaview' });
      },
      verrest(p) {
        this.$store.dispatch('programa/selectPrograma', p);
        window.sessionStorage.setItem('xprograma', JSON.stringify(p));
        // http://localhost:8080/#/prospectos_ins/8330?asesor_id=43&persona_id=173218&persona_name=Victor%20Hugo%20Casillo%20Mamani&inscripcion_id=218088
        this.$router.push({ name: 'programaview',query: {programa_id: p.id} });
      },
      misInscripciones() {
        this.$router.push({ name: 'misinscripciones', params: {} });
      },
      modalExito() {
        this.cursor = 10000000;
        // this.programas = [];
        this.getDataProgramas();
      },
      modalExitof(idpos, newFase) {
        var pro = this.programas.find((x) => x.id == idpos);
        pro.fase = newFase;
        this.seleccionadof.prog.fase = newFase;
      },
      aprobarPrograma(p) { 
        if(!p.fecha_inicio){
          this.$root.$notify.show(`No se puede aprobar un programa sin fecha de inicio.`, {
            color: 'red',
            x: 'right',
          });
          return;
        }
        this.$store.dispatch('programa/selectPrograma', p);
        this.seleccionadof.prog = p;
      },
      abrirgeneradorEnlace(p) {
        this.$refs.generarenlace.open(p);
      },
      abrirretrasosprog(prog) {
        // window.console.log(prog);
        let p = prog.single_name;
        this.$router.push(`/retrasosprog?p=${p}&idprograma=${prog.id}`);
      },
      preDeleteProgramita(p) {
        this.$store.dispatch('programa/selectPrograma', p);
        if (p.fase > 0) {
          //solo en preinscripcion
          this.$notify(error('Error de Fase', 'Los programas solo se pueden eliminar en fase de PRE-INSCRIPCIONES.'));
          return;
        }

        var vue = this;
        var opt = {
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para eliminar este programa.',
          okText: 'Eliminar Programa',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar Eliminacion',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible, tenga cuidado.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function (dialog) {
            vue.deleteProgramita(p, dialog);
          })
          .catch(function () {});
      },

      deleteProgramita(p, dialog) {
        this.$store.dispatch('programa/selectPrograma', p);
        var vue = this;
        var sql = gql`mutation{ deletePrograma(input:{ programa_id:${p.id} }){ ok,errors{message} } }`;
        this.$apollo
          .mutate({
            mutation: sql,
          })
          .then((data) => {
            var datos = data.data.deletePrograma;
            if (datos.ok) {
              this.programas.find((x) => x.id == p.id);
            } else {
              var errores = JSON.stringify(datos.errors);
              var obj = JSON.parse(errores);
              var vals = '';
              obj.forEach(function (k) {
                delete k.__typename;
                vals += Object.values(k) + ' \n\t';
              });
              vue.$notify(error('No se pudo eliminar', vals));
            }
            dialog.close();
          })
          .catch((error) => {
            dialog.close();
            this.msg = error;
            vue.$notify(parseJsonError(error, 'deletePrograma'));
          });
      },

      enviarCorreoDefault(programa) {
        this.$store.dispatch('programa/selectPrograma', programa);
        var est = '$nombre';
        this.correoto.xid = programa.id;
        this.correoto.xtitle = 'Enviar Datos de acceso a todos';
        this.correoto.xbody = `
        <html>
          <h3>Estimado: ${est}</h3>
          <p> Por medio de este correo le enviamos sus datos de acceso a la plataforma Moodle</p>
          <p>
            Enlace: <b>${process.env.VUE_APP_DOMAIN_MOODLE}</b> <br/>
            Usuario: <b>$usuario</b> <br/>
            Clave: <b>$clave</b>
          <p>
            Confirme sus datos personales para su certificado:<br/>
            Nombres: ${est} <br/>
            Email: $email <br/>
            Celular: $celu
          </p>
        </html>
        `;
        this.correoto.all = true;
        this.correoto.isDefault = true;
        this.correoto.xsql = null;
        this.correoto.xcorreo = null;
        this.correoto.xasunto = 'Datos de acceso';
        this.correoto.xnombre = '';
      },
      enviarCorreo(pro) {
        this.correoto.xid = pro.id;
        this.correoto.xtitle = 'Enviar Correo Personalizado a todos';
        this.correoto.xbody = '';
        this.correoto.all = true;
        this.correoto.isDefault = false;
        this.correoto.xsql = null;
        this.correoto.xcorreo = null;
        this.correoto.xasunto = '';
        this.correoto.xnombre = '';
      },
      modalExitoCorreo() {},
      openVerificadorCobranzas(programa) {
        window.localStorage.setItem('select_programa', JSON.stringify(programa));
        this.$store.dispatch('programa/selectPrograma', programa);
        this.$router.push('/verificador_cobranzas?programa_id=' + programa.id);
      },
      openMoodleCategory(p){
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if(unidad!=1 && unidad!=5){
          this.$root.$notify.show(`Esta funcionalidad solo funciona para el moodle de ESAM`, {
              color: 'red',
              x: 'right',
            });
          return;
        }
        const categoryid = p.course_category_id;
        let url = `https://moodle.esam.edu.bo/course/index.php?categoryid=${categoryid}`;
        if(unidad==5) url = `https://campus.esamlatam.com/course/index.php?categoryid=${categoryid}`
        if(unidad==15) url = `https://campus.upi.edu.pa/course/index.php?categoryid=${categoryid}`
        /* window.console.log(this.$store.state.CARGO.sede.unidad_negocio);
        window.console.log(url); */
        window.open(url, '_blank');
      },

      buscador(filtro) {
        window.sessionStorage.setItem('xfind_prog', filtro);
        filtro = filtro.toUpperCase();
        var table, tr, tdd, td, i, j, txtValue;
        table = document.getElementById('midatatable');
        tr = table.getElementsByTagName('tr');

        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName('td');
          for (j = 1; j < tdd.length; j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = '';
                break;
              } else {
                tr[i].style.display = 'none';
              }
            }
          }
        }
      },
    },
    mounted() {
      let userid = this.$store.state.DATA_USER.id;
      let userrobertocca = 32173;
      this.permitido = userid == userrobertocca;
      //this.filter_programas();
      this.getEstadosPrograma().then(() => this.getDataProgramas());
      const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
      const comparer = (idx, asc) => (a, b) =>
        ((v1, v2) => (v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)))(
          getCellValue(asc ? a : b, idx),
          getCellValue(asc ? b : a, idx),
        );
      document.querySelectorAll('th').forEach((th) =>
        th.addEventListener('click', () => {
          const table = th.closest('table');
          const tbody = table.querySelector('tbody');
          Array.from(tbody.querySelectorAll('tr'))
            .sort(comparer(Array.from(th.parentNode.children).indexOf(th), (this.asc = !this.asc)))
            .forEach((tr, ind) => {
              tr.firstChild.innerHTML = ind + 1;
              tbody.appendChild(tr);
            });
        }),
      );
    },
  };
</script>
